// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { productPrimaryVideoStyles } from "@west/App/Components/ProductVideoPlayerDetails/ProductPrimaryVideo";
import PlayCircle from "@west/XDL/Icons/PlayCircle";
import { color } from "@west/XDL/Utilities";
import { css } from "styled-components";

productPrimaryVideoStyles.centeringWrapper = {
    css: css`
        position: relative;
        min-height: 300px;
        margin: 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img {
            height: auto;
            max-width: 100%;
        }

        &:hover {
            ${IconWrapper} {
                svg {
                    color: ${color("common.ui9")};
                }
            }
        }
    `,
};

productPrimaryVideoStyles.playIcon = {
    src: PlayCircle,
    size: 80,
    color: "common.ui1",
    css: css`
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 100%;
    `,
};
productPrimaryVideoStyles.darkOverlay = {
    css: css`
        background-color: ${color("common.black", 0.66)};
        position: absolute;
        height: 100%;
        width: 100%;
    `,
};
